import React from "react";
import Layout from "../../layout";
import LayoutDashboard from "../referralslayout"
import ClientHeaderFilter from "./clientHeaderFilter";
const ClientsReferrals = () => {
  return (
    <Layout>
      <LayoutDashboard>
        <div className="rounded-xl md:border md:border-neutral-100 shadow-md dark:border-neutral-800 md:p-6">
          <ClientHeaderFilter heading={'Clients'}/>
        </div>
      </LayoutDashboard>
    </Layout>
  );
};
export default ClientsReferrals;